import script from "./ResultsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsTab.vue?vue&type=script&setup=true&lang=js"

import "./ResultsTab.vue?vue&type=style&index=0&id=72bf2c27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bf2c27"]])

export default __exports__